import yourls from "yourls-api";

const YOURLS_URL = process.env.REACT_APP_YOURLS_URL;
const YOURLS_USERNAME = process.env.REACT_APP_YOURLS_USERNAME;
const YOURLS_PASSWORD = process.env.REACT_APP_YOURLS_PASSWORD;

yourls.connect(`${YOURLS_URL}/yourls-api.php`, {
	username: YOURLS_USERNAME,
	password: YOURLS_PASSWORD
});

export function shorten(url, keyword = "", cb) {
	yourls.shorten(url.replace(/\s/g, ""), keyword, cb);
};

export function loadYourls(cb) {
	yourls.stats({
		filter: "last",
		limit: 100,
		start: 0
	}, cb);
};